import { oc } from "@orpc/contract";
import { z } from "zod";
import { CreateEmployeeCompensationInputSchema, UpdateEmployeeCompensationInputSchema, EmployeeCompensationResponseSchema, } from "@hourly/api/employeeCompensation";
// ===== COMPENSATION CONTRACTS =====
const createCompensationContract = oc
    .route({ method: "POST", path: "/compensations", successStatus: 201 })
    .input(CreateEmployeeCompensationInputSchema)
    .output(EmployeeCompensationResponseSchema);
const updateCompensationContract = oc
    .route({ method: "PUT", path: "/compensations/{id}" })
    .input(UpdateEmployeeCompensationInputSchema.extend({
    id: z.uuid(),
    employmentId: z.uuid(),
}))
    .output(EmployeeCompensationResponseSchema);
const deleteCompensationContract = oc
    .route({ method: "DELETE", path: "/compensations/{id}", successStatus: 204 })
    .input(z.object({ id: z.uuid(), employmentId: z.uuid() }))
    .output(z.void());
export const compensationContract = {
    create: createCompensationContract,
    update: updateCompensationContract,
    delete: deleteCompensationContract,
};
//# sourceMappingURL=compensation.js.map